import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { HEADER, NAVBAR } from '../../config';
import useAuth from '../../hooks/useAuth';
import NavbarVertical from '../dashboard/navbar/NavbarVertical';
import DashboardHeader from '../dashboard/header';
import MainFooter from './MainFooter';
import MainHeader from './MainHeader';
import MobileBottomNav from '../dashboard/header/MobileBottomNav';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    // width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    // marginLeft: 158,
    // ...(collapseClick && {
    //   marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    // }),
  },
}));

const AuthMainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

export default function MainLayout() {
  const { user } = useAuth();

  return <>{user ? user.role === 'user' ? <UserLayout /> : <OrgLayout /> : <AnonUserLayout />}</>;
}

// export function UserLayout() {
//   const { collapseClick, isCollapse } = useCollapseDrawer();
//   const [open, setOpen] = useState(false);

//   return (
//     <Box
//       sx={{
//         display: { lg: 'flex' },
//         minHeight: { lg: 1 },
//       }}
//     >
//       <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />
//         <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

//       <AuthMainStyle collapseClick={collapseClick}>
//         <Outlet />
//         <Box sx={{ flexGrow: 1 }} />

//       {/* <MainFooter /> */}
//       </AuthMainStyle>

//     </Box>
//   );
// };
export function UserLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />
      <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <AuthMainStyle
        collapseClick={collapseClick}
        sx={{
          pb: { xs: `${HEADER.MOBILE_HEIGHT + 24}px`, lg: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 24}px` },
        }}
      >
        <Outlet />
        <Box sx={{ flexGrow: 1 }} />
      </AuthMainStyle>

      <MobileBottomNav header={HEADER}/>
    </Box>
  );
}

export function OrgLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />
      <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <AuthMainStyle collapseClick={collapseClick}>
        <Outlet />
        <Box sx={{ flexGrow: 1 }} />

        {/* <MainFooter /> */}
      </AuthMainStyle>
    </Box>
  );
}

export function AnonUserLayout() {
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainHeader isCollapse={collapseClick} onOpenSidebar={() => setOpen(true)} />

      <MainStyle collapseClick={collapseClick}>
        <Outlet />
      </MainStyle>

      <Box sx={{ flexGrow: 1 }} />

      <MainFooter />
    </Stack>
  );
}
